var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRadioSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icRadioSelected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Friends-&-Favourites",
    transform: "translate(-314.000000, -458.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Radio---selected",
    transform: "translate(314.000000, 458.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0.420000, 0.420000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.16,10.0802688 C20.16,4.52832556 15.6322121,0 10.0802688,0 C4.52832556,0 0,4.52832556 0,10.0802688 C0,15.6322121 4.52832556,20.16 10.0802688,20.16 C15.6322121,20.16 20.16,15.6322121 20.16,10.0802688 Z",
    id: "Fill-3",
    fill: "#7EC34D"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFFFFF",
    points: "13.5798131 5.88 8.53981312 10.831932 6.5797229 8.9067 5.04 10.420392 8.53981312 13.86 15.12 7.393692"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRadioSelected);
export default __webpack_public_path__ + "static/media/icRadioSelected.0c244c3c68734bc59c1b7cc4100225fc.svg";
export { ForwardRef as ReactComponent };